<app-mobile-preview>
  <iframe class="template-iframe" #iframe sandbox="allow-same-origin" scrolling="auto" frameborder="0"></iframe>
</app-mobile-preview>
